import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/hot1.png'


const _withScopeId = n => (_pushScopeId("data-v-a2edad54"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrap",
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.28rem","font-style":"normal","font-weight":"600","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"0.32rem"}
  }),
  /*#__PURE__*/_createTextVNode("热门目的地 ")
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import { ref, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { NavBar, Search } from "vant";

export default /*#__PURE__*/_defineComponent({
  name: 'Search',
  setup(__props) {

const router = useRouter();
const value = ref("");
const cityLList = ref([
  {
    name: "日本",
    img: require("../assets/icon/rb.png"),
  },
  {
    name: "韩国",
    img: require("../assets/icon/hg.png"),
  },
  {
    name: "新加坡",
    img: require("../assets/icon/xjp.png"),
  },
  {
    name: "马来西亚",
    img: require("../assets/icon/mlxy.png"),
  },
  {
    name: "泰国",
    img: require("../assets/icon/tg.png"),
  },
  {
    name: "印度尼西亚",
    img: require("../assets/icon/ydnxy.png"),
  },
  {
    name: "越南",
    img: require("../assets/icon/yn.png"),
  },
  {
    name: "菲律宾",
    img: require("../assets/icon/flb.png"),
  },
  {
    name: "欧洲多国",
    img: require("../assets/icon/ozdg.png"),
    isCustomFlag: true,
    title: '英国'
  },
  {
    name: "美国",
    img: require("../assets/icon/mg.png"),
  },
  {
    name: "澳大利亚",
    img: require("../assets/icon/adly.png"),
  },
  {
    name: "新西兰",
    img: require("../assets/icon/xxl.png"),
  },
  // {
  //   name: "加拿大",
  //   img: require("../assets/icon/jnd.png"),
  // },
  {
    name: "中国香港",
    img: require("../assets/icon/xg.png"),
  },
  {
    name: "中国澳门",
    img: require("../assets/icon/am.png"),
  },
  {
    name: "中国台湾",
    img: require("../assets/icon/tw.png"),
  },
  {
    name: "沙特阿拉伯",
    img: require("../assets/icon/st.png"),
  },
  // {
  //   name: "阿拉伯",
  //   img: require("../assets/icon/alb.png"),
  // },
  {
    name: "印度",
    img: require("../assets/icon/yd.png"),
  },
  {
    name: "俄罗斯",
    img: require("../assets/icon/els.png"),
  },
  // {
  //   name: "阿联酋",
  //   img: require("../assets/icon/alq.png"),
  // },
]);
const dataList = computed(() => {
  return cityLList.value.filter((item) => {
    return item.name.indexOf(value.value) !== -1;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "目的地",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createVNode(_unref(Search), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
      shape: "round",
      background: "#fff",
      placeholder: "搜索目的地"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "dataItem",
          key: item.name,
          onClick: ($event: any) => (
          _unref(router).push({
            name: 'hotGoods',
            query: {
              name: item.isCustomFlag ? item.title :item.name,
            },
          })
        )
        }, [
          _createElementVNode("img", {
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_5),
          _createTextVNode(_toDisplayString(item.name), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})